/**
 * Builds a tree structure from a flat list of nodes using `parentId` references.
 */
export function buildNodeTree(items) {
    var _a;
    const map = new Map();
    for (const item of items) {
        map.set(item.id, Object.assign(Object.assign({}, item), { children: [] }));
    }
    const nodes = [];
    for (const node of map.values()) {
        if (node.parentId && map.has(node.parentId)) {
            (_a = map.get(node.parentId).children) === null || _a === void 0 ? void 0 : _a.push(node);
        }
        else {
            nodes.push(node);
        }
    }
    return { nodes, map };
}
